import { useGraphqlQuery } from "@harea/component";
import { TContractsResponse } from "@harea/component";
import { OrganizationEmployeesQuery } from "../query/OrganizationEmployeesQuery";

export const useEmployeeListQuery = () => {
  return useGraphqlQuery<OrganizationEmployeesQuery, TContractsResponse>(
    new OrganizationEmployeesQuery(),
    { suspense: true },
  );
};
